import { useRef, useCallback } from 'react';

// creates a field handler factory for form inputs
export const useFieldHandlerFactory = (onChange, options = {}) => {
  const { transformValue } = options;
  const fieldHandlers = useRef({});
  
  const getFieldHandler = useCallback((field, ...additionalArgs) => {
    // create a unique key that includes field and any additional args
    const key = additionalArgs.length > 0 
      ? `${field}_${additionalArgs.join('_')}` 
      : field;
    
    if (!fieldHandlers.current[key]) {
      if (transformValue) {
        fieldHandlers.current[key] = (e) => {
          const transformedValue = transformValue(e, field);
          onChange(field, transformedValue, ...additionalArgs);
        };
      } else {
        fieldHandlers.current[key] = (e) => {
          onChange(field, e.target.value, ...additionalArgs);
        };
      }
    }
    return fieldHandlers.current[key];
  }, [onChange, transformValue]);
  
  return getFieldHandler;
};

// creates a field handler for document/item fields with index
export const useIndexedFieldHandlerFactory = (onChange) => {
  const fieldHandlers = useRef({});
  
  const getFieldHandler = useCallback((index, fieldOrIndex2, optionalField) => {
    // if 3 parameters: (index1, index2, optionalField) - for nested structures like embalaje/marca If 2 parameters: (index, field) - for simple indexed fields like documents
    let key;
    let handler;
    
    if (optionalField !== undefined) {
      // 3-parameter pattern: (embajaIndex, marcaIndex) or (embajaIndex, field, value)
      key = `${index}_${fieldOrIndex2}_${optionalField}`;
      handler = (e) => onChange(index, fieldOrIndex2, optionalField, e.target.value);
    } else {
      // 2-parameter pattern: (docIndex, field)
      key = `${index}_${fieldOrIndex2}`;
      handler = (e) => onChange(index, fieldOrIndex2, e.target.value);
    }
    
    if (!fieldHandlers.current[key]) {
      fieldHandlers.current[key] = handler;
    }
    return fieldHandlers.current[key];
  }, [onChange]);
  
  return getFieldHandler;
};

